import React from 'react';

import { DownOutlined, RightOutlined } from '@ant-design/icons';
import { Button, Dropdown, Layout, Menu, MenuProps, Space } from 'antd';
import { MenuItemType } from 'antd/es/menu/interface';
import { COMPANY_NAME } from 'app-config';

import { useAppDispatch, useAppSelector } from 'segments/hooks';

import { logout } from 'features/auth';
import { LangSelector } from 'features/change-lang';
import { selectAccountData } from 'features/user';


import './DashboardSidebar.scss';

type Props = {
  className?: string;
  items: MenuItemType[];
};

const DashboardSidebar = ({ className = '', items }: Props) => {
  const { name } = useAppSelector(selectAccountData);
  const dispatch = useAppDispatch();

  const dropdownItems: MenuProps['items'] = [{
    key: 'logout',
    label: 'Logout',
    onClick: () => dispatch(logout())
  }];

  return (
    <Layout.Sider
      className={`dashboard-sidebar ${className}`}
      breakpoint="xxl"
      collapsible
      collapsedWidth="0"
      theme="light"
      width={220}
      trigger={
        <Button
          style={{
            border: 'none',
            padding: '0px',
            height: '42px',
            borderRadius: '0px 12px 12px 0px',
            backgroundColor: '#4182F8',
            color: 'white'
          }}
        >
          <RightOutlined />
        </Button>
      }
      zeroWidthTriggerStyle={{
        transform: 'translateY(-50%)',
        top: '50%',
        border: 'none',
        left: '100%',
        position: 'absolute',
        fontSize: '20px'
      }}
    >
      <div className="dashboard-sidebar__content">
        <div>
          <p className="dashboard-sidebar__logo">{COMPANY_NAME}</p>
          <Menu
            className="dashboard-sidebar__menu"
            mode="vertical"
            items={items}
          />
        </div>
        <div className="dashboard-sidebar__btns">
          {/* <Timezone /> */}
          <LangSelector title />
          <h4 style={{margin:'0px'}}>
            <Dropdown menu={{ items: dropdownItems }} trigger={['click']}>
              <Button>
                <Space>
                  {name}
                  <DownOutlined className="user__icon" />
                </Space>
              </Button>
            </Dropdown>
          </h4>
        </div>
      </div>
    </Layout.Sider >
  );
};

export default DashboardSidebar;
